import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './FAQPage.css';

const FAQ_ITEMS = [
  { q: 'What age groups do you accept?', a: 'We accept children ages 2 to 12 for our preschool and afterschool programs.' },
  { q: 'Are meals provided?', a: 'Yes. Meals are regulated by the New York State under the Child & Adult Food Care Program (CACFP). Breakfast is served with a cut-off at 8:30 AM.' },
  { q: 'What are your school hours?', a: 'We are open Monday through Friday from 8:00 AM to 7:00 PM. Arrival cut-off for preschoolers is 9:00 AM.' },
  { q: 'Is the program licensed?', a: 'Yes, our program is fully licensed and meets all state requirements for child care and early education.' },
  { q: 'How do I schedule a tour?', a: 'You can schedule a tour by calling us at 718-462-0776 or visiting our Contact page.' },
  { q: 'What is your teacher-to-child ratio?', a: 'We maintain small class sizes with a low teacher-to-child ratio to ensure personalized attention for every child.' },
  { q: 'Do you offer potty training support?', a: 'Yes, we work with families to support potty training in a supportive, age-appropriate way.' },
  { q: 'What happens if my child gets sick at school?', a: 'If your child becomes ill at school, we will contact you immediately. We provide first aid only; staff do not administer medication.' },
];

function FAQPage() {
  const [openFaqIndex, setOpenFaqIndex] = useState(null);

  const toggleFaq = (idx) => {
    setOpenFaqIndex((prev) => (prev === idx ? null : idx));
  };

  return (
    <main className="faq-page">
      <section className="faq-section" aria-label="Frequently asked questions">
        <div className="faq-inner">
          <h1 className="faq-title">Frequently Asked Questions</h1>
          <p className="faq-subtitle">
            Find answers to common questions about our programs, policies, and enrollment.
          </p>
          <div className="faq-list">
            {FAQ_ITEMS.map((item, idx) => (
              <div
                key={idx}
                className={`faq-item ${openFaqIndex === idx ? 'is-open' : ''}`}
              >
                <button
                  type="button"
                  className="faq-question"
                  onClick={() => toggleFaq(idx)}
                  aria-expanded={openFaqIndex === idx}
                  aria-controls={`faq-answer-${idx}`}
                  id={`faq-question-${idx}`}
                >
                  <span>{item.q}</span>
                  <span className="faq-chevron" aria-hidden="true">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                </button>
                <div
                  id={`faq-answer-${idx}`}
                  className="faq-answer"
                  role="region"
                  aria-labelledby={`faq-question-${idx}`}
                >
                  <p>{item.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="faq-ready-cta" aria-label="Ready to apply">
        <div className="faq-ready-cta-inner">
          <h2 className="faq-ready-cta-title">Ready to Apply?</h2>
          <p className="faq-ready-cta-desc">
            Start your application today or schedule a tour to learn more about our programs.
          </p>
          <div className="faq-ready-cta-actions">
            <Link to={{ pathname: '/admissions', hash: 'schedule-tour' }} className="btn btn-primary faq-ready-cta-primary">
              <span className="btn-icon" aria-hidden="true">
                <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="3" y="4" width="14" height="13" rx="2" stroke="currentColor" strokeWidth="1.6" />
                  <path d="M3 8H17" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                  <path d="M8 3V6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                  <path d="M12 3V6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                  <rect x="7" y="10" width="2.2" height="2.2" rx="0.4" fill="currentColor" />
                </svg>
              </span>
              Schedule Tour
            </Link>
            <Link to="/contact" className="btn btn-outline faq-ready-cta-secondary">
              Inquiry Now
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}

export default FAQPage;
